module.exports = __webpack_public_path__ + "static/rumia-willbud-mobile-65ca57fecfb890c0c8346e85f375c19b.jpg";